mutation ($colorId: ID, $iconId: ID, $name: String!, $studentIds: [ID], $teamId: ID!) {
  grade_level_create(colorId: $colorId, iconId: $iconId, name: $name, studentIds: $studentIds, teamId: $teamId) {
    canCurrentDelete
    name
    color {
      id
      name
      displayName
    }
    icon {
      id
      name
      displayName
    }
    id
    order
    orderDenominator
    orderNumerator
    studentList(sortBy: ALPHA, sortDirection: ASC, page: 1) {
      list {
        id
        first
        last
        positivity
        mostRecentCommunication
        communicationCount
        gradeLevel {
          id
          name
          order
        }
      }
      count
      remaining
      pageSize
    }
  }
}
